<template>
  <one-column-sidebar-left
      :id="$route.params.id"
      :tab-selector="$store.getters.getSfxdataType($route.params.id) + 'tab'"
      back-button-tab-selector="sfxbackbutton"
      sub-menu-selector="librarypanel"
  >
    <info-panel :id="$route.params.id"
                slot="sidebarLeft"
                :created="$store.getters.getSfxdataCreationDate($route.params.id)"
                :image-editable="hasWritingAccess"
                :last-change="$store.getters.getSfxdataChangeDate($route.params.id)"
                :organization="$store.getters.getSfxdataOrganization($route.params.id)"
                :preview-uri="$store.getters.getSfxdataPreviewUri($route.params.id)"
                preview-id="sfxedit"
                upload-type="Asset"

/>
        <info-panel
                slot="sidebarLeft"
                :id="$route.params.id"
                :tags="$store.getters.getSfxdataTags($route.params.id)"
                :taggable="hasWritingAccess"
                @removeTag="removeTag"
                @addTag="addTag"
                :key="'infopanel2'"
                preview-id="sfxedit"
                :limit-tags-to-organization="$store.getters.getSfxdataOrganization($route.params.id)"
        />
      <team-attacher
          v-if="$store.getters.getSfxdataOrganization($route.params.id)"
          class="mt-3"
          slot="sidebarLeft"
          :id="$route.params.id"
          :teams="teams"
          storeName="Asset"
          :limit-by-organization-id="$store.getters.getSfxdataOrganization($route.params.id)"
          :read-only="!hasWritingAccess"
          @added="loadAssetTeams"
          @removed="loadAssetTeams"
      />

    <div slot="mainContent">
      <div class="row">
        <name-display-edit-block
          :max-name-length="500"
            class="col-8 ml-0 pl-1"
            :id="$route.params.id"
            :display-name="$store.getters.getSfxdataDisplayName($route.params.id)"
            :name="$store.getters.getSfxdataName($route.params.id)"
            :organization-id="$store.getters.getSfxdataOrganization($route.params.id)"
            icon="sfxdata"
            store-name="Sfxdata"
            :editable="hasWritingAccess"
        />
      </div>
      <content-description-block
          :id="$route.params.id"
          :value="$store.getters.getSfxdataDescription(id)"
          store-name="Sfxdata"
          :editable="hasWritingAccess"
      />
      <div  class="row">
        <state-setter
            v-if="$store.getters.getSfxdataState($route.params.id)&& hasWritingAccess"
            :given-state="$store.getters.getSfxdataState($route.params.id)"
            :target-id="$route.params.id"
            class="col-12 col-md-4 mb-2 mt-2"
            store-name="Sfxdata"
        /></div>
           <div v-if="$store.getters.isSFXMember || $store.getters.isSuperAdmin" class="row">
        <div class="w-100"/>
        <glb-conversion-trigger
            v-if="!hasGlb && !hideGlbForm"
            :asset-id="$route.params.id"
            class="col-12 col-md-4 mt-3 mb-3"
            type="helper"
            @taskStarted="hideGlbForm = true"
        />
        <div class="w-100"/>
        <div v-if="!hasGlb && hideGlbForm" class="form-error col-12 col-md-4 ml-3">
          {{ $t('yourDataGetsConverted') }}
        </div>
      </div>



      <div class="row">
        <div class="col-12">
          <info-panel
              :initially-collapsed="true"
              :collapsible="true"
              class="new-style bright"
              info-panel-header="Usage"
              preview-id="usage">
            <div slot="info">
              <asset-usage :asset-id="$route.params.id" />
            </div>
          </info-panel>
        </div>
        <div class="col-12 col-md-6 no-gutters">
          <info-panel
              v-if="hasWritingAccess"
              :collapsible="true"
              info-panel-header="files"
              preview-id="fileview"
          >
            <div slot="info">
              <file-list
                  :file-types="['fbx', 'vab']"
                  :target-id="$route.params.id"
                  store-name="Asset"
              />
            </div>
          </info-panel>
        </div>
        <div class="w-100"/>
        <div class="col-12 col-md-6 no-gutters">
          <info-panel
              v-if="$store.getters.isSuperAdmin"
              :collapsible="true"
              :initially-collapsed="true"
              info-panel-header="sfx edit"
              preview-id="metasetattacher"
          >
            <meta-set-attacher
                slot="info"
                :given-meta-sets="$store.getters.getSfxdataMetaSets(id)"
                :target-id="$route.params.id"
                store-name="Asset"
                @added="loadSfx"
                @removed="loadSfx"
            />
          </info-panel>
        </div>
        <meta-panel
            v-for="(item) in $store.getters.getSfxdataMetaSets(id)"
            :key="item.id" :fields="item.metaFields" :organization-ids="[$store.getters.getSfxdataOrganization(id)]"
            :title="item.description" class="col-12 col-md-6" icon-left="folder"
            store-name="Sfxdata"
            type="sfxdata"
            :editable="hasWritingAccess"
            @updated="loadSfx"
        />
      </div>

    </div>
  </one-column-sidebar-left>
</template>

<script>
import InfoPanel from "../components/InfoPanel";
import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft";
import ContentDescriptionBlock from "../components/ContentDescriptionBlock";
import MetaPanel from "../components/widgets/meta/MetaPanel";
import MetaSetAttacher from "@/components/widgets/meta/MetaSetAttacher";
import TeamAttacher from "@/components/organizations/TeamAttacher";
import StateSetter from "@/components/StateSetter";
import FileList from "@/components/files/FileList";
import GlbConversionTrigger from "../components/assemblies/GlbConversionTrigger";
import NameDisplayEditBlock from "@/components/NameDisplayEditBlock.vue";
import AssetUsage from "@/components/AssetUsage.vue";

export default {
  name: 'SFXEdit',
  components: {
    AssetUsage,
    NameDisplayEditBlock,
    InfoPanel,
    MetaPanel,
    OneColumnSidebarLeft,
    ContentDescriptionBlock,
    MetaSetAttacher,
    TeamAttacher,
    StateSetter,
    FileList,
    GlbConversionTrigger
  },
  data() {
    return {
      id: '',
      teams: [],
      hasGlb: true,
      hideGlbForm: false,
      hasWritingAccess: false
    };
  },
  beforeMount() {
    this.loadSfx();
    this.loadAssetTeams();
    this.loadStorage();
    this.id = this.$route.params.id;
  },
  methods: {
    /**
     * Reroutes the user to the access denied page
     * */
    denyAccess() {
      this.$router.push('/access-denied');
    },
    async checkAccess(asset) {
      const hasAccess = await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'read',
        teams: asset.teams,
        organizationId: asset.organizationId
      })
      this.hasWritingAccess = await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'writeMetaSet',
        teams: asset.teams,
        organizationId: asset.organizationId
      })
      if (!hasAccess) {
        this.denyAccess();
      }
    },
    loadAssetTeams() {
      this.$store.dispatch('clientLoadAssetTeams', {
        id: this.$route.params.id
      }).then(data => {
        this.teams = data;
      });
    },
    loadStorage() {
      this.$store.dispatch('clientListAssetParts', {id: this.$route.params.id})
          .then(files => {
            if (!files || !files.filter(item => {
              return item.key === 'lod0.glb'
            }).length) {
              this.hasGlb = false;
            }
          })
    },
    loadSfx() {
      this.$store.dispatch('loadSfxdata', {
        id: this.$route.params.id,
        include: 'teams,tags,metaSets,taskManagerRow' // keep include teams or access check will fail
      }).then(async data => {
        if(data) {
          const {taskManagerRows} = data;
          if(taskManagerRows && taskManagerRows.length) {
            this.hideGlbForm = true;
          }
        }
        await this.checkAccess(data);
      }).catch(e => {
        if (e.status === 401) {
          this.$router.push('/access-denied');
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    removeTag: function (tag) {
      this.$store.dispatch('removeSfxdataTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
    addTag: function (tag) {
      this.$store.dispatch('addSfxdataTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
  },
}
</script>